(() => {
  const init = () => {
    if (!document.body.classList.contains('template-product')) return;

    const description = document.querySelector('#MainContent .product__description');
    const productGrid = document.querySelector('#MainContent .product');
    if (!description || !productGrid || description.dataset.optimusPremiumReady === 'true') return;

    description.dataset.optimusPremiumReady = 'true';

    const shell = document.createElement('section');
    shell.className = 'optimus-premium-description-shell';
    shell.setAttribute('aria-label', 'Description du produit');

    const header = document.createElement('div');
    header.className = 'optimus-premium-description-header';
    header.innerHTML = '<span class="optimus-premium-description-kicker">FICHE PRODUIT</span><h2>Description & caractéristiques</h2>';

    shell.appendChild(header);
    shell.appendChild(description);
    productGrid.insertAdjacentElement('afterend', shell);

    const children = Array.from(description.children);
    const directDiv = children.find((el) => el.tagName === 'DIV');
    const directList = children.find((el) => el.tagName === 'UL' || el.tagName === 'OL');
    const directParagraphs = children.filter((el) => el.tagName === 'P');

    if (directParagraphs[0]) directParagraphs[0].classList.add('optimus-description-intro');
    if (directDiv) directDiv.classList.add('optimus-description-eu');
    if (directList) directList.classList.add('optimus-description-specs');
    if (directParagraphs.length > 1) directParagraphs[directParagraphs.length - 1].classList.add('optimus-description-note');

    if (directList && !directList.previousElementSibling?.classList.contains('optimus-description-card-title')) {
      const title = document.createElement('h3');
      title.className = 'optimus-description-card-title optimus-description-specs-title';
      title.textContent = 'Caractéristiques techniques';
      directList.insertAdjacentElement('beforebegin', title);
    }

    if (directDiv) {
      const firstP = directDiv.querySelector(':scope > p:first-child');
      if (firstP) firstP.classList.add('optimus-description-eu-title');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();